var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMageDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 17.2803C11.931 17.2803 13.7834 16.513 15.1492 15.1472C16.5149 13.7814 17.2822 11.9291 17.2822 9.99756C17.2822 8.06606 16.5149 6.21368 15.1492 4.8479C13.7834 3.48213 11.931 2.71484 9.99951 2.71484C8.06802 2.71484 6.21563 3.48213 4.84985 4.8479C3.48408 6.21368 2.7168 8.06606 2.7168 9.99756C2.7168 11.9291 3.48408 13.7814 4.84985 15.1472C6.21563 16.513 8.06802 17.2803 9.99951 17.2803Z",
    stroke: "#64748B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08008 11.5545C8.12089 12.0253 8.34481 12.4613 8.70369 12.7687C9.06258 13.0762 9.52776 13.2305 9.99925 13.1986C11.5474 13.1986 11.9184 12.3094 11.9184 11.5545C11.9184 10.7996 11.2787 9.99997 9.99925 9.99997C8.7198 9.99997 8.08008 9.49458 8.08008 8.46463C8.09201 8.22768 8.15174 7.9956 8.25568 7.78234C8.35963 7.56908 8.50563 7.37904 8.68491 7.22366C8.8642 7.06828 9.07305 6.95077 9.29893 6.8782C9.5248 6.80562 9.76301 6.77948 9.99925 6.80135C10.4711 6.78103 10.9327 6.94203 11.2896 7.25132C11.6465 7.5606 11.8715 7.99473 11.9184 8.46463M9.99925 14.1562V13.3246M9.99925 5.83984V6.79879",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageDollar);
export default __webpack_public_path__ + "static/media/mage_dollar.0b0246ca929f796f1b038859eb8ad9ba.svg";
export { ForwardRef as ReactComponent };